import React, { useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const CustomAlert = ({ open, alertType, text }) => {
  const classes = useStyles();
  const [openAlert, setOpenAlert] = useState(open ? open : false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };
  return (
    <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={`${alertType}`}>
        {text}
      </Alert>
    </Snackbar>
  );
};

export default React.memo(CustomAlert);
